<template>
  <v-container class="container">
    <v-form ref="form" v-model="valid" lazy-validation>
      <div style=" display: flex; padding-block-start: 50px;">
        <div icon @click="setNormalView" class="box">
          <img src="https://dunedingoescarting.com/wp-content/uploads/2019/09/map-1272165_960_720.png" width="40px"
            class="icon" />
        </div>
        <div icon @click="setTrafficView" class="box">
          <img
            src="https://e7.pngegg.com/pngimages/520/93/png-clipart-computer-icons-traffic-light-symbol-traffic-light-driving-traffic-sign.png"
            width="40px" class="icon" />
        </div>
        <div align="center" v-if="expires_in!=-1">
          <h4>Tiempo actualización en: {{ this.expires_in }}</h4>
        </div>
      </div>
      <GmapMap ref="gmap" :center="this.mapView" :zoom="17" :map-type-id="this.mapTypeId" :options="{
  
      }" style="height: 50.6vh;">
        <GmapMarker :id="m.id" :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true"
          :icon="m.icon" />
        <gmap-info-window :id="'info-' + m.imei + '-' + m.idTraccar" :key="'info-' + m.imei + '-' + m.idTraccar"
          v-for="(m, index) in markers" :position="m.position" :options="{
            pixelOffset: {
              width: 0,
              height: -50
            },
            disableAutoPan: true
          }">
          <p>{{ m.name }}</p>
        </gmap-info-window>
      </GmapMap>
      <div align="center" style="  background-color: white; z-index: 1000 !important;">
        <table width="100%">
          <tr>
            <td>
              <div align="center">
                <span v-if="(!this.device.offline && this.device.status === 'rely')  || (!this.device.offline && this.device.accStatus == '1' && this.device.speed == '0')">
                  0
                </span>
                <span v-else style="font-weight: bold">{{ this.device.accStatus == '1' ? (this.device.speed*1.852).toFixed(0) :
                  '0' }}</span>
                <br>
                <span style="font-weight: bold">KM/H</span>
              </div>
            </td>
            <td>
              <div align="center">
                <div v-if="(!this.device.offline && this.device.status === 'rely')  || (!this.device.offline && this.device.accStatus == '1' && this.device.speed == '0')"
                  class="styleDeviceStatus2">
                  <div align="center">
                    <span style="color: #ffd500; font-weight: bold;font-size: 14px">DETENIDO </span><br>
                    <span style="color: #ffd500; font-weight: bold;font-size: 14px">PRENDIDO</span>
                    <span
                    style="color: #ffd500; font-weight: bold;font-size: 14px">{{ this.$store.getters.msToTime(this.device.timeRely) }}</span>
                  </div>
                </div>
                <div v-else-if="!this.device.offline && this.device.accStatus == '1' && parseInt(this.device.speed) > 0"
                  class="styleDeviceStatus">
                  <div align="center">
                    <span style="color: greenyellow; font-weight: bold; font-size: 14px ">MOVIMIENTO</span>
                  </div>
                </div>
                <div v-else-if="!this.device.offline && this.device.accStatus == '0'" class="styleDeviceStatus">
                  <div align="center">
                    <span style="color: red; font-weight: bold;font-size: 14px">DETENIDO</span><br>
                    <span
                      style="color: red; font-weight: bold;font-size: 14px">{{ this.$store.getters.msToTime(this.device.timeStop).toUpperCase() }}</span>
                  </div>
                </div>
                <div v-else-if="this.device.offline" class="styleDeviceStatus">
                  <div align="center">
                    <span style="color: gray; font-weight: bold;font-size: 14px">FUERA DE LINEA</span>

                  </div>
                </div>

              </div>
            </td>
            <td>
              <div align="center">
                <div v-if="!this.device.offline">
                  <img src="https://icons.iconarchive.com/icons/icons8/android/512/Transport-Engine-icon.png" alt=""
                    style="width: 20px; padding-top:10px;">
                  <span style="font-size: 14px">{{
                    this.device.accStatus == '1' ? 'ENCENDIDO' : 'APAGADO'
                    }}</span><br>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <div class="containerdiv">
          <div class="details-container">
            <img src="../../../assets/odometer.png" alt=""
              style="width: 35px; position:absolute; margin-top: -10px !important;">
            <span style="padding-left: 40px; margin-top:30px;">{{ (this.device.odometer).toFixed(2) }} KM</span>
          </div>
          <div class="details-container">
            <div>
              <img v-if="this.device.sat" src="../../../assets/satellite.png" alt=""
                style="width: 40px; position:absolute; margin-top: -10px !important;">
              <span v-if="this.device.sat" style="padding-left: 40px; margin-top:20px;"> Satelites:
                {{this.device.sat}}</span>
            </div>
          </div>
        </div>
        <div class="containerdiv">
          <div class="image-container">
            <img :src="this.device.image" alt="" width="80px">
          </div>
          <div class="details-container">
            <div>
              DISPOSITIVO: {{this.device.name}}
            </div>
            <div v-if="$store.getters.isAdmin">
              IMEI: {{this.device.imei}}
            </div>
          </div>
        </div>
        <div style="padding-block-start: 10px;">
          <div>
            <a  href="#" @click.prevent="toggleDirection">
              {{ viewDirection ? 'Actualizar dirección' : 'Ver dirección' }}
            </a>
            <div v-if="viewDirection">
              <h4 v-if="direction">Dirección: {{ direction }}</h4>
            </div>
          </div>
        </div>
        <br>
        <v-btn color="primary" size="small" @click="selectedItemMap()">Actualizar</v-btn>
        <v-btn color="primary" size="small" @click="getActualPosition()">Mi Posición</v-btn>
      </div>
    </v-form>
  </v-container>
</template>
<script>
import VueTimepicker from 'vue2-timepicker/src'
import $ from "jquery";

export default {
  props: [
    'devices',
    'device'
  ],
  components: {
    VueTimepicker
  },
  data() {
    return {
      search: '',
      valid: false,
      markers: [],
      deviceObject: {id: "", value: "", date: new Date()},
      singleSelect: false,
      marker: null,
      mapView: {lat: -0.190029, lng: -78.482114},
      expires_in: 0,
      selectedInMap: "",
      dialogReport: false,
      searched: false,
      reportType: '',
      interval: 0,
      countTimesCall: 0,
      directionDevice: 0,
      imageDevice: "",
      trafficLayer: null, // Traffic layer reference
      isTrafficView: false, // Boolean to track if traffic view is enabled
      mapTypeId: 'roadmap',
      direction: "",
      myPosition: false,
      viewDirection: false,
    };
  },
  watch: {},
  methods: {
    createInterval() {
      clearInterval(this.$store.state.intervalMap)
      this.$store.state.intervalMap = setInterval(() => {
        if (this.expires_in === 0) {
          this.expires_in = 10
          this.selectedItemMap()
        } else {
          this.expires_in = this.expires_in - 1;
        }
      }, 1000);
    },

    initializeMap() {
      this.$refs.gmap.$mapPromise.then(map => {
        this.trafficLayer = new google.maps.TrafficLayer();
        this.updateMapView(); // Ensure the map starts with the correct view
      });
    },
    setNormalView() {
      this.isTrafficView = false;
      this.updateMapView();
    },
    setTrafficView() {
      this.isTrafficView = true;
      this.updateMapView();
    },
    updateMapView() {
      this.$refs.gmap.$mapPromise.then(map => {
        if (this.isTrafficView) {
          this.trafficLayer.setMap(map);
        } else {
          this.trafficLayer.setMap(null);
        }
      });
    },
    success(position) {
      let respPosition = {
        position: {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          imei: this.device.imei
        }
      }
      this.markers.push(respPosition)
      this.mapView = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      }
    },
    toggleDirection() {
      this.$store.dispatch('getStreetFromCoordinates', {
        lat: this.lat,
        lng: this.lng,
        imei: this.device.imei
      }).then(response1 => {
        this.direction = response1
        if(!this.viewDirection){
          this.viewDirection = !this.viewDirection;
        }
      })
    },
    successRecurrent(position) {
      let respPosition = {
              position: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
                imei: this.device.imei
              }
            }
      this.markers.push(respPosition)
    },

    getActualPosition(){
      function error(msg) {
        alert('error');
      }
      if (navigator.geolocation) {
        this.myPosition = true,
        navigator.geolocation.getCurrentPosition(this.success, error);

      } else {
        error('not supported');
      }
    },
    getActualPositionRecurrent(){
      function error(msg) {
        alert('error');
      }
      if (navigator.geolocation) {
        this.myPosition = true,
        navigator.geolocation.getCurrentPosition(this.successRecurrent, error);

      } else {
        error('not supported');
      }
    },
    selectedItemMap() {
      this.countTimesCall++;
      this.singleSelect = false
      this.$store.dispatch('getDevicesLocationTraccar', this.device.idTraccar).then(response => {
        if (response.data.result.length == 0) {
          this.dialogError = true
        } else {
          // Set coordinates from device latest position
          this.lat = response.data.result[0].lat;
          this.lng = response.data.result[0].lng;
          let queryParam = "deviceId="+this.device.idTraccar+"&from="+this.dateStart()+"&"+"to="+this.dateEnd()
          this.timeStop = 0;

          // Get the latest events
          this.$store.dispatch('getDevicesLocationTraccarAlarm', queryParam).then(responseEvent => {
            this.directionDevice = response.data.result[0].direction
            let image = this.device.image
            this.accStatus = response.data.result[0].accStatus;
            let motion = response.data.result[0].motion;
            if (response.data.result[0].status === 'rely' || (this.accStatus == '1' && motion == '0')) {
              image = image.replace("1.", "A.");
            } else if (this.accStatus == '1' && parseInt(response.data.result[0].speed) > 0) {
              image = image.replace("1.", "V.");
            } else if (this.accStatus == '0') {
              image = image.replace("1.", "R.");
            } else {
              image = image.replace("1.", "G.");
            }

            let now = new Date();
            let deviceTime = new Date(response.data.result[0].deviceTime);
            let minutesForOffline = 7 * 60 * 1000; // 10 minutes
            // If the latest position device time is grater than minutesForOffline then
            // assing time between deviceTime and now to timeStop
            let timeStop = {}
            let offline = false
            let timeDifference = now - deviceTime;

            let timeOffline = timeDifference;
            let minutesOffline = timeDifference / 1000 / 60;
            //************************IMPORTANT TO TRACE******************************
            //console.log('Time Difference (minutes):', minutesOffline);

            if (timeDifference > minutesForOffline) {
              image = image.replace("1.", "G.");
              image = image.replace("V.", "G.");
              image = image.replace("R.", "G.");
              image = image.replace("A.", "G.");
              timeStop = (deviceTime.getTime() - (now.getTime())) * -1;
              offline = true;
            } else {
              offline = false;
            }

            // If device is stopped then get timeStop from event response when type is ignitionOff
            if (!this.offline && this.accStatus == '0') {
              for (let i = 0; i < responseEvent.data.length; i++) {
                if (responseEvent.data[i].type == "ignitionOff") {
                  deviceTime = new Date(responseEvent.data[i].eventTime);
                  timeStop = (now.getTime() - deviceTime.getTime());
                  break;
                }
              }
            }

            if (response.data.result[0].status === "rely" || (this.accStatus == '1' && motion == '0')) {
              let queryParam = "deviceId=" + this.device.idTraccar
              this.$store.dispatch('getDevicesLocationTraccarLastRely', queryParam).then(responseReport => {
                if (responseReport == null || responseReport === undefined || responseReport.data == null) {
                  return 0
                }
                let lastTime = responseReport.data.result[0]
                let gpsTime = new Date(lastTime.deviceTime);
                //console.log(gpsTime)
                let timeDifferenceRely = now - gpsTime;
                //console.log(timeDifferenceRely)
                let minutesRely = timeDifferenceRely / 1000 / 60;
                //console.log('Time Difference Rely (minutes):', minutesRely);
                this.device.timeRely = timeDifferenceRely

              });
            }

            this.imageDevice = image
            let respPosition = {
              position: {
                lat: this.lat,
                lng: this.lng,
                imei: this.device.imei
              },
              icon: {
                url2: image,
                url: image,
                scaledSize: { width: 55, height: 55, f: 'px', b: 'px' },
                rotation: 120,
                id: "markerId"
              },
              imei: this.device.imei,
              name: this.device.name,
              sim: this.device.sim,
              model: this.device.model,
              image: image,
              directionDevice: response.data.result[0].direction,
              accStatus: this.accStatus,
              speed: response.data.result[0].speed,
              blocked: this.device.lastAction == 'Bloquear' ? true : false,
              timeOffline: timeOffline,
              timeStop: timeStop,
              offline: offline,
              status: response.data.result[0].status
            }
            if (this.myPosition) {
              this.getActualPositionRecurrent();
            }
            if (response.data.result[0].attributes.sat) {
              this.device.sat = response.data.result[0].attributes.sat
            }

            this.mapView = {
              lat: this.lat,
              lng: this.lng,
            }

            this.markers = []
            this.markers.push(respPosition)
            this.device.selected = true
            this.device.accStatus = this.accStatus
            this.device.speed = response.data.result[0].speed
            this.device.offline = offline
            this.device.timeOffline = timeOffline
            this.device.timeStop = timeStop
            this.device.status = response.data.result[0].status


           
          })
        }
      })
      this.singleSelect = true
    },
    dateStart(){
      let date = new Date();
      // Five days ago
      date.setTime(date.getTime() - (5 * 24 * 60 * 60 * 1000)); // Convert hours to milliseconds - 60 minutes to an hour, 60 seconds to a minute, 1000 milliseconds to a second

      var day = date.getDate() + "";
      var month = date.getMonth()+1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours()+"";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";


      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },
    dateEnd(){
      let date = new Date();
      var day = date.getDate() + "";
      var month = date.getMonth()+1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours() + "";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";

      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },
    checkZero(data){
      if(data.toLocaleString().length == 1){
        data = "0" + data;
      }
      return data;
    },
  },
  computed: {},
  mounted() {
    this.initializeMap();
  },
  created() {
    this.createInterval()
    clearInterval(this.$store.state.intervalMapDevice)
    this.$store.state.intervalMapDevice = setInterval(() => {
      if(this.markers.length>0){
        for (const marker of this.markers) {
          const $element = $('img[src*="' + marker.image + '"]').parent();
            $element.hide(); // Hide the element
            $element.css('transform', 'rotate(' + marker.directionDevice + 'deg)'); // Rotate the element
            $element.show(); // Show the element again
        }
      }
    }, 1000);
    
  },
};
</script>

<style scoped>
.container {
  max-width: 100% !important;
  padding: 0%;
}
td
{
  height: 50px;
  width: 50px;
}

#cssTable td
{
  text-align: center;
  vertical-align: middle;
}

  .containerdiv {
    display: flex;
  }
  .image-container {
    padding-top: 4px;
    padding-left: 30px;
    width: 50%;
    height: 50px;
  }
  .details-container {
    margin-top: 20px;
    margin-left: 20px;
    text-align: left;
    width: 50%;
  }
  p {
    margin-bottom: 0 !important;
  }
  .box {
    width: 25px;
    height: 25px;
    padding-inline-end: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/mobile/MapMobile.vue